module.exports = __webpack_public_path__ + "static/media/me.3f3afaac.jpg";